export const AUTHOR_CHANGED = "filter/authorChanged";
export const CATEGORY_CHANGED = "filter/categoryChanged";
export const SEARCH_NAME = "filter/searchName";
export const CLEAR_FILTER = "filter/clearFilter";
